import { render, staticRenderFns } from "./PatientComplementariesTab.vue?vue&type=template&id=6fcfcef9&"
import script from "./PatientComplementariesTab.vue?vue&type=script&lang=js&"
export * from "./PatientComplementariesTab.vue?vue&type=script&lang=js&"
import style0 from "./PatientComplementariesTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports